import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Articles from "@/pages/admin/Articles";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/articles/")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-articles", path: "/admin/articles", title: "Cloud Admin Articles", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Articles /></AdminLayout>,
});
